'use client';

import { Button } from '@components/common';
import { AdjustmentsHorizontalIcon } from '@heroicons/react/24/outline';
import { useContext, useMemo } from 'react';
import { FilterDrawerContext } from '@components/contexts/FilterDrawerContext';
import { HeaderSearchContext } from '@components/contexts/HeaderSearchContext';
import { countAppliedFilters } from '@components/features/filters/helpers/countAppliedFilters';
import { useIsJobListRoute } from '@components/contexts/JobListRouteContext';

/**
 * @description Filter button for the header. Only renders on the job list page.
 * Uses JobListRouteContext for visibility — no URL detection needed.
 */
export const FilterButton = () => {
  const isJobListRoute = useIsJobListRoute();
  // Get filter drawer context safely
  const context = useContext(FilterDrawerContext);
  const headerSearch = useContext(HeaderSearchContext);

  const { toggleDrawer } = context ?? { toggleDrawer: () => {} };

  // Compute applied filters count from header search context
  const count = useMemo(
    () => countAppliedFilters(headerSearch?.queryParams),
    [headerSearch?.queryParams],
  );

  // Render component
  // If context is not available, don't render the button
  if (!isJobListRoute || !context) {
    return null;
  }

  return (
    <div className="relative">
      <Button
        styling="soft"
        rounding="normal"
        color="ink-medium"
        onClick={toggleDrawer}
        size="xs"
      >
        <AdjustmentsHorizontalIcon className="size-6" />
      </Button>
      {count > 0 && (
        <span className="absolute right-0 top-0 -translate-y-1/4 translate-x-1/4 rounded-full bg-primary px-1.5 py-0.5 text-center text-nano text-white shadow-md">
          {count}
        </span>
      )}
    </div>
  );
};
